import { BaseServices, HttpMethod } from '@services/base'

export default async (biometricToken: string, accessToken?: string) => {
  const pathname = process.env.REACT_APP_BIOMETRICS_VALIDATE_WEB
  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
    biometricToken,
  }

  const response = await BaseServices.request<{ isValid: boolean }>({
    headers,
    pathname,
    method,
    host,
  })
  return response
}
